import { render, staticRenderFns } from "./RentBox_Component.vue?vue&type=template&id=68f70a6a&scoped=true&"
import script from "./RentBox_Component.vue?vue&type=script&lang=js&"
export * from "./RentBox_Component.vue?vue&type=script&lang=js&"
import style0 from "./RentBox_Component.vue?vue&type=style&index=0&id=68f70a6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f70a6a",
  null
  
)

export default component.exports